<app-page-body [class]="'tw-pt-2'" *ngIf="!isVisibleHelpPage">
  <!-- header -->
  <app-page-header
    custom-header
    [title]="'pages.confirmSmartSmsRequest.title' | translate"
    [loading]="loading"
    [showAddBtn]="false"
    [showAuditBtn]="false"
    (onShowHelp)="onShowHelpPage()"
  >
    <div class="card-toolbar" before-btns>
      @if (!formPageConfig?.isEditMode) {
      <!-- open sendQueue -->
      <page-header-btn
        [name]="
          permissionService.userState()?.isSuperAdmin
            ? 'sendQueue'
            : 'currentUserSendQueue'
        "
        icon="mdi-email-multiple-outline"
        [title]="
          permissionService.userState()?.isSuperAdmin
            ? 'pages.sendQueue.title'
            : 'pages.sendQueue.userTitle'
        "
        btnColor="btn-light"
      ></page-header-btn>

      <!-- open outboxMessages -->
      <page-header-btn
        [name]="
          permissionService.userState()?.isSuperAdmin
            ? 'userOutboxMessages'
            : 'currentUserOutboxMessages'
        "
        icon="mdi-inbox-arrow-up"
        iconSize="mdi-22px"
        [title]="
          permissionService.userState()?.isSuperAdmin
            ? 'pages.outboxMessages.title'
            : 'pages.outboxMessages.userTitle'
        "
        btnColor="btn-light-info"
      ></page-header-btn>
      }
    </div>
  </app-page-header>

  <div class="app-page-content row">
    <div class="tw-h-full secondary-panel">
      <div *ngIf="updateModel == null">
        <!-- smart sms operators -->
        <app-smart-sms-operators
          (selectedOperator)="selectedOperator = $event"
          [isRefreshPage]="isRefreshPage"
          [isShowToggle]="true"
          [isExistsMCI]="isExistsMCI"
          [isExistsIrancell]="isExistsIrancell"
          [isExistsRightel]="isExistsRightel"
          (operators)="operators = $event"
          (isRefreshPage)="isRefreshPage = $event"
        ></app-smart-sms-operators>
      </div>

      <div class="row">
        <div
          class="xl:tw-w-1/3 tw-w-full tw-my-2"
          [class]="!showSidePanel ? 'order-1' : ''"
        >
          <fieldset class="secondary-panel">
            <legend class="tw-flex-center">
              <i class="mdi mdi-earth-box mdi-24px tw-ml-2"></i>
              {{ pageVocabs + "legends.smsPart" | translate }}
            </legend>
            <!-- senderNumberId + smsBody -->
            <!-- [smsBody]="smsBody" -->
            <div
              *ngIf="isPeriodicRequest"
              class="alert alert-primary tw-leading-6 tw-font-medium senders-list tw-text-right tw-mb-5 tw-pb-3"
              [innerHtml]="'messages.smartPeriodicMessage' | translate"
            ></div>

            <app-sms-body
              [numbersType]="'isSmartSendSms'"
              [sendType]="SendTypes.Smart"
              [smsCp]="SmsCp.MCI"
              [useType]="UseTypes.Normal"
              [form]="form"
              valueMaxWidth="2xl:tw-max-w-[230px] xl:tw-max-w-[165px] md:tw-max-w-[500px] sm:tw-max-w-[420px] tw-max-w-[140px]"
              [disabled]="false"
              smsBodyControlName="smsBody"
              socialMediaMessageControlName="socialMediaFileId"
              socialMediaApplicationControlName="socialMediaApplicationId"
              senderNumberControlName="senderNumberId"
              [isAddSignature]="true"
              [isAddHeader]="true"
              [isEditMode]="formPageConfig?.isEditMode"
              [optionValue]="'number'"
              [smsBody]="updateModel?.smsBody"
              [senderNumberId]="
                !updateModel ? senderNumberId : updateModel?.privateNumberNumber
              "
              (finalSmsBody)="smsBody = $event"
              (senderNumber)="
                getSenderNumber($event); changeValidations($event)
              "
              (senderNumberId)="senderNumberId = $event"
              (smsCount)="smsCount = $event"
              [isSmartSmsTitle]="true"
              [isRefreshForm]="isRefreshPage"
              [isShowSmsCp]="true"
              [isSmartSend]="true"
              (socialMediaMessageDetails)="socialMediaSendDetailModel = $event"
            >
            </app-sms-body>

            <app-date-time-picker
              [disabled]="isDisabled"
              [config]="directDateTimeConfig"
              (dateTime)="sendDateTime = $event"
              *ngIf="isPeriodicRequest == false && dataLoaded"
            >
            </app-date-time-picker>

            <!--#region periodic data-->
            <ng-container *ngIf="isPeriodicRequest && dataLoaded">
              <!-- date time filter selector * required item  -->
              <app-periodic-date-time-picker
                class="tw-mt-5"
                [config]="periodicDateTimeConfig"
                (startDateTime)="periodicStartTime = $event"
                (endDateTime)="periodicEndTime = $event"
              >
              </app-periodic-date-time-picker>

              <div class="row">
                <!-- startTime -->
                <div class="md:tw-w-1/2">
                  <timepicker
                    label="common.startTimeAtDay"
                    [value]="updateModel?.startTimeAtDay"
                    (value)="startTimeAtDay = $event"
                    [control]="form?.get('startTimeAtDay')"
                    [maxTime]="endVal"
                    [confirmBtnClass]="'btn' | themeColor"
                  >
                  </timepicker>
                </div>

                <!-- endTime -->
                <div class="md:tw-w-1/2">
                  <timepicker
                    label="common.endTimeAtDay"
                    [value]="updateModel?.endTimeAtDay"
                    (value)="endTimeAtDay = $event"
                    [control]="form?.get('endTimeAtDay')"
                    [minTime]="startVal"
                    [confirmBtnClass]="'btn' | themeColor"
                  >
                  </timepicker>
                </div>

                <div class="w-full">
                  <smart-sms-request-periodic-patterns
                    [startDateTime]="periodicStartTime"
                    [endDateTime]="periodicEndTime"
                    [disabled]="!periodicStartTime || !periodicEndTime"
                    [periodicPattern]="periodicPattern"
                    [selectedDays]="selectedDateTimesForPeriodicPattern"
                    (selectedDaysChange)="
                      selectedDateTimesForPeriodicPattern = $event
                    "
                    (periodicPatternChange)="periodicPattern = $event"
                  />
                </div>
              </div>

              <div class="tw-w-full">
                <app-periodic-type
                  inputClass=""
                  [isSmartSms]="true"
                  [config]="periodicTypeConfig"
                  (periodType)="sentDelayType = $event"
                  (periodText)="sentDelayValue = $event"
                >
                </app-periodic-type>
              </div>

              <div class="tw-w-full">
                <div class="row">
                  <div class="md:tw-w-1/2">
                    <custom-select-search
                      [label]="fields + 'sendCountType'"
                      [items]="
                        $any([
                          { value: 0, name: fields + 'percentage' | translate },
                          { value: 1, name: fields + 'count' | translate }
                        ])
                      "
                      optionTitle="name"
                      optionValue="value"
                      [removable]="false"
                      [value]="
                        updateModel == null || isSmartCountAsPercent ? 0 : 1
                      "
                      (valueChange)="sendPeriodicTypePercentateChange($event)"
                    >
                    </custom-select-search>
                  </div>
                  <div class="md:tw-w-1/2">
                    <form-field
                      *ngIf="isSmartCountAsPercent"
                      class="tw-w-full"
                      type="number"
                      [label]="fields + 'percentageToSend'"
                      [value]="smartCountPercent"
                      [min]="1"
                      [max]="100"
                      (valueChange)="setPeriodicSentPercentage($event)"
                    >
                      <span suffix-content>
                        <i class="mdi mdi-percent"></i>
                      </span>
                    </form-field>

                    <form-field
                      *ngIf="isSmartCountAsPercent == false"
                      class="tw-w-full"
                      type="tel"
                      [isOnlyNumber]="true"
                      [label]="fields + 'countToSend'"
                      [min]="1"
                      [value]="count | numberSeparator"
                      (valueChange)="setPeriodicSendCount($event)"
                    >
                      <span suffix-content matSuffix>
                        <i class="mdi mdi-account-multiple"></i>
                      </span>
                    </form-field>
                  </div>
                </div>
              </div>

              <div class="tw-w-full">
                <div class="row">
                  <!-- maxSendCount -->
                  <div class="md:tw-w-1/2">
                    <form-field
                      [value]="updateModel?.maxSendCount"
                      (valueChange)="maxSendCount = $event"
                      type="tel"
                      [hasNumberSeparator]="true"
                      [control]="form?.get('maxSendCount')"
                      [label]="fields + 'maxSendCount' | translate"
                    >
                    </form-field>
                  </div>
                  <!-- maxDailySendCount -->
                  <div class="md:tw-w-1/2">
                    <form-field
                      [value]="updateModel?.maxDailySendCount"
                      (valueChange)="maxDailySendCount = $event"
                      type="tel"
                      [hasNumberSeparator]="true"
                      [control]="form?.get('maxDailySendCount')"
                      [label]="fields + 'maxDailySendCount' | translate"
                    >
                    </form-field>
                  </div>

                  <div class="tw-mb-4">
                    <mat-slide-toggle
                      formControlName="continueSendIfAnyOperatorHaveError"
                      [(ngModel)]="continueSendIfAnyOperatorHaveError"
                      (change)="
                        onChangeIsShowContinueSendIfAnyOperatorHaveError($event)
                      "
                    >
                      {{
                        "common.continueSendIfAnyOperatorHaveError" | translate
                      }}
                    </mat-slide-toggle>
                  </div>
                </div>
              </div>

              <!-- description for user -->
              <div class="tw-text-lg dark:tw-text-gray-300">
                <span>
                  {{ pageVocabs + "legends.yourCampaignFrom" | translate }}
                </span>
                <b class="text-teal">{{
                  periodicStartTime | dateTimeConvertor : appLang | checkValue
                }}</b>
                <span>
                  {{ pageVocabs + "legends.untilDate" | translate }}
                </span>
                <b class="text-teal">{{
                  periodicEndTime | dateTimeConvertor : appLang | checkValue
                }}</b>
                <span>
                  {{ pageVocabs + "legends.every" | translate }}
                  <b class="text-teal"
                    >{{ sentDelayValue }}
                    {{ pageVocabs + "legends.period" | translate }}
                  </b>
                  {{ pageVocabs + "legends.runAnd" | translate }}
                </span>
                <ng-container *ngIf="isSmartCountAsPercent">
                  <b class="text-teal"> {{ smartCountPercent }}% </b>
                </ng-container>
                <ng-container *ngIf="!isSmartCountAsPercent">
                  <b class="text-teal">
                    {{ count }}
                    {{ pageVocabs + "legends.person" | translate }}
                  </b>
                </ng-container>
                <span>
                  {{
                    pageVocabs + "legends.ofTheTargetNumbersWillReceiveSMS"
                      | translate
                  }}.
                </span>
              </div>

              <div class="my-2 text-center"></div>
            </ng-container>
            <!--#endregion-->

            <app-view-filters #filterViewer></app-view-filters>
            <div
              class="tw-pr-[10px] ltr:tw-pl-[10px] tw-pl-[10px] ltr:tw-pr-[10px] tw-min-h-[100px]"
              *ngIf="data?.numberPrefix"
            >
              <list-group-item
                [label]="'common.mobilePrefix' | translate"
                [value]="data?.numberPrefix"
                marginClass="tw-my-0"
              >
              </list-group-item>
            </div>

            <div
              *ngIf="
                data?.recipients?.length > 0 &&
                !isPeriodicRequest &&
                isWelcomeType()
              "
            >
              <div
                *ngFor="let item of data?.recipients; let i = index"
                class="max-w-sm rounded overflow-hidden border-1 tw-p-1 m-1"
              >
                <div class="tw-flex-center">
                  <!-- mci -->
                  <span
                    class="text-mci"
                    *ngIf="item.operator == SmsAggregator.MCI"
                  >
                    {{ item.operator | enumToText : SmsAggregatorsEnumValues }}
                    <img
                      src="/assets/media/svg/operator/mci.svg"
                      class="tw-mx-1"
                      width="40"
                    />
                  </span>
                  <!-- mtn -->
                  <span
                    class="text-mtn"
                    *ngIf="item.operator == SmsAggregator.Irancell"
                  >
                    {{ item.operator | enumToText : SmsAggregatorsEnumValues }}
                    <img
                      src="/assets/media/svg/operator/mtn.svg"
                      class="tw-mx-1"
                      width="40"
                    />
                  </span>
                  <!-- rightel -->
                  <span
                    class="text-rightel"
                    *ngIf="item.operator == SmsAggregator.Rightel"
                  >
                    {{ item.operator | enumToText : SmsAggregatorsEnumValues }}
                    <img
                      src="/assets/media/svg/operator/rightel.svg"
                      class="tw-mx-1"
                      width="40"
                    />
                  </span>
                  <!-- other -->
                  <span
                    class="text-brown tw-font-semibold"
                    *ngIf="
                      item.operator == SmsAggregator.Other ||
                      item.operator == SmsAggregator.NotValid
                    "
                  >
                    {{ item.operator | enumToText : SmsAggregatorsEnumValues }}
                  </span>
                </div>

                <div class="row tw-p-[12px]">
                  <!-- fromIndex -->
                  <form-field
                    class="tw-w-1/2"
                    label="pages.sendSmsFromMap.fields.startFrom"
                    [value]="
                      item?.fromIndex <= 0
                        ? 1
                        : (item?.fromIndex | numberSeparator)
                    "
                    [attr.data-from-index-input-id]="item.id"
                    [isOnlyNumber]="true"
                    type="tel"
                    [min]="1"
                    classList="index-input tw-mx-1 dir-ltr"
                    [isDisabled]="Model[i].total == 0"
                    [hasNumberSeparator]="true"
                    (change)="changeStartFrom(item, Model[i].total, $event)"
                  >
                  </form-field>

                  <!-- count -->
                  <form-field
                    class="tw-w-1/2"
                    label="pages.sendSmsFromMap.fields.count"
                    [value]="item?.count | numberSeparator"
                    [attr.data-count-input-id]="item.id"
                    [isOnlyNumber]="true"
                    type="tel"
                    [min]="1"
                    classList="index-input tw-mx-1 dir-ltr"
                    [isDisabled]="Model[i].total == 0"
                    [hasNumberSeparator]="true"
                    (change)="changeCount(item, Model[i].total, $event)"
                  >
                  </form-field>

                  <mat-error *ngIf="isWrongIndex">
                    <div class="error-text">
                      <span class="text-error-color">{{
                        "messages.wrongIndex" | translate
                      }}</span>
                    </div>
                  </mat-error>

                  <!--price fa-->
                  <list-group-item
                    class="tw-w-1/2"
                    [label]="'common.priceFa' | translate"
                    [value]="item?.persianPrice"
                  >
                  </list-group-item>

                  <!--price en-->
                  <list-group-item
                    class="tw-w-1/2"
                    [label]="'common.priceEn' | translate"
                    [value]="item?.englishPrice"
                  >
                  </list-group-item>

                  <!--total-->
                  <list-group-item
                    class=""
                    [label]="'common.allCount' | translate"
                    [value]="Model[i].total | numberSeparator"
                  >
                  </list-group-item>
                </div>
              </div>

              <!-- submit btn-->
              <div class="tw-mt-2">
                <button
                  class="btn tw-h-full btn-hover-rise button-shadow tw-w-full tw-flex-center font-weight-500"
                  [themeColor]="'btn'"
                  type="button"
                  (click)="onSubmit()"
                >
                  {{ "common.send" | translate }}
                </button>
              </div>
            </div>
          </fieldset>
        </div>

        <div
          class="tw-w-full tw-my-2"
          [class]="!showSidePanel ? 'xl:tw-w-full' : 'xl:tw-w-2/3'"
        >
          <fieldset class="tw-sticky tw-top-[120px] secondary-panel">
            <legend class="tw-flex-center">
              <i class="mdi mdi-earth-box mdi-24px tw-ml-2"></i>
              {{ pageVocabs + "legends.publicMap" | translate }}
            </legend>

            <div class="row">
              <div
                class="tw-w-full"
                [ngClass]="{
                  'tw-relative disable-mapboxgl-canvas': !isShowMap
                }"
              >
                @if(!isShowMap){
                <div
                  class="tw-absolute tw-w-full tw-h-full tw-bg-slate-50 dark:tw-bg-slate-800 tw-opacity-40 tw-z-[1] tw-right-0 tw-flex-center"
                ></div>
                <span
                  class="tw-absolute tw-text-gray-500 dark:tw-text-white tw-font-extrabold tw-text-xl text-color tw-top-2/4 tw-left-0 tw-right-0 tw-text-center tw-z-[1]"
                  >{{ "messages.disableMapInSmartSmsDetail" | translate }}</span
                >
                }

                <app-smart-send-confirmation-map-component
                  #Map
                  (OnLoad)="onMapLoad()"
                  [selectedOperator]="selectedOperator"
                  [isRefreshPage]="isRefreshPage"
                  [isUpdateMode]="isUpdateMode"
                  [SmsPartCount]="smsCount"
                  [ShowPanel]="false"
                  [isShowRecipients]="isShowMap"
                  [showDetail]="isPeriodicRequest == false"
                  [ShowAddToPublicPlace]="true"
                  (OnNextStepClick)="onSubmit()"
                  (expandMap)="isShowSidePanel($event)"
                ></app-smart-send-confirmation-map-component>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
    </div>

    <!--#region campaign buttons-->
    <div
      *ngIf="isPeriodicRequest && dataLoaded"
      class="row tw-flex tw-justify-end tw-items-center tw-px-0"
    >
      <div class="md:tw-w-1/6 tw-w-5/6 tw-px-0">
        <button
          *ngIf="!updateModel"
          type="button"
          mat-ripple
          class="btn tw-w-full tw-mt-5 button-shadow btn-hover-rise"
          [themeColor]="'btn-gradient'"
          mat-button
          (click)="onCreatePeriodicSmsRecepient()"
          [disabled]="this.form.valid == false"
        >
          {{ pageVocabs + "createCampain" | translate }}
          <i class="fas fa-paper-plane tw-text-2xl"></i>
        </button>
        <button
          *ngIf="updateModel"
          type="button"
          mat-ripple
          class="btn tw-w-full tw-mt-5 button-shadow btn-hover-rise"
          [themeColor]="'btn-gradient'"
          mat-button
          (click)="onUpdatePeriodicSmsRecepient()"
          [disabled]="this.form.valid == false"
        >
          {{ pageVocabs + "editCampaign" | translate }}
          <i class="fas fa-paper-plane tw-text-2xl"></i>
        </button>
      </div>
    </div>
    <!--#endregion-->
  </div>
</app-page-body>

<!--------------------------------------------------------------- help ---------------->
<ng-container *ngIf="isVisibleHelpPage">
  <app-help-page
    [menuTitle]="title"
    (hidePage)="onHideHelpPage()"
    title="pages.confirmSmartSmsRequest.title"
  >
  </app-help-page>
</ng-container>

<!-- calcLoading -->
<app-special-loading
  special-loading
  *ngIf="calcLoading"
  imgSrc="assets/media/gif/calculate.gif"
  imgMaxWidth="110px"
  message="messages.calcSmsPrice"
>
</app-special-loading>


<!-- sendLoading -->
<app-special-loading
  special-loading
  *ngIf="sendLoading"
  imgSrc="assets/media/gif/sending.gif"
  [message]="
    !isPeriodicRequest ? 'messages.sendingSms' : 'messages.creatingCampaign'
  "
>
</app-special-loading>
